import { Tooltip, TooltipProps } from "@mui/material"
import TooltipConstraints from "../TooltipConstraints/TooltipConstraints"
import { PropsWithChildren } from "react"
import { ValidatorResult } from "@/interfaces/api/forms/forms_types"

interface TooltipFieldProps extends Omit<TooltipProps, 'title'> {
  validations: ValidatorResult[]
  hasHelperText?: boolean
}

export default function TooltipField({ validations, hasHelperText = false, children, ...props }: PropsWithChildren<TooltipFieldProps> ) {
  const hasValidationToShow = validations.length > 0 && validations.some(v => v.show)

  if (!hasValidationToShow) return children

  return (
    <Tooltip
      title={<TooltipConstraints validations={validations} />}
      slotProps={{
        popper: {
          className: 'constraints',
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, hasHelperText ? -24 : 0], // Adjust the vertical offset as needed
              },
            },
          ],
        }
      }}
      {...props}
      data-testid="TooltipField"
    >
      {children}
    </Tooltip>
  )
}